import React from 'react';
import { MimaButton, MimaText, Modal } from '../../components';
import styles from '../../assets/styles/Inventory/DeleteModal.module.scss';
import { inventoryStore } from '../../stores';
import { toJS } from 'mobx';

const DeleteModal = ({ closeModal, onDelete, loading, type }) => {

    const { selectedStock, selectedProduct } = inventoryStore;


    return (
        <Modal
            closeModal={closeModal}
            goBack={closeModal}
        >
            <MimaText variant="subtitleBold" align="center" mb={3}>
				{`Delete ${type} Type`}
			</MimaText>
            <MimaText
                width={38}
                align={'center'}
                mb={2}
            >
                Are you sure you want to
                delete <span style={{ fontWeight: '700', color: 'var(--color-primary)' }}>{
                type !== 'Product'
                ? selectedStock.product?.name :
                selectedProduct.name}</span> {""}
                and its variations?
            </MimaText>
            <div className='modal__beside'>
                <MimaButton
                    title={'Yes'}
                    width={18}
                    onClick={() => { onDelete(selectedStock._id) }}
                    loading={loading}
                />
                <MimaButton
                    title={'Cancel'}
                    width={18}
                    type="button"
                    buttonColor={'grey'}
                    onClick={() => {
                        closeModal()
                    }}
                />
            </div>
        </Modal>
    )
}

export default DeleteModal;